const colors = {
  yellow: {
    0: '#ffffff',
    100: '#fff9ea',
    200: '#fff1cb',
    300: '#ffe9ab',
    400: '#ffe08c',
    500: '#ffd86d',
    600: '#ffcf4d',
    700: '#ffc72e', //primary
    800: '#d9a927',
    900: '#b38b20',
  },
  green: {
    0: '#ffffff',
    100: '#f4fceb',
    200: '#e4f8cd',
    300: '#d3f3af',
    400: '#c3ef90',
    500: '#b3eb72',
    600: '#a2e654',
    700: '#92e236', //primary
    800: '#7cc02e',
    900: '#669e26',
  },
  red: {
    0: '#ffffff',
    100: '#fdecea',
    200: '#facfcb',
    300: '#f7b1ac',
    400: '#f3948d',
    500: '#f0776d',
    600: '#ed5a4e',
    700: '#ea3d2f', //primary
    800: '#c73428',
    900: '#a42b21',
  },
  cyan: {
    0: '#ffffff',
    100: '#e8fbff',
    200: '#c4f4ff',
    300: '#a1eeff',
    400: '#7ee7ff',
    500: '#5be1ff',
    600: '#37daff',
    700: '#14d4ff', //primary
    800: '#11b4d9',
    900: '#0e94b3',
  },
  purple: {
    0: '#ffffff',
    100: '#f1f0fe',
    200: '#dcd9fc',
    300: '#c7c2f9',
    400: '#b2abf7',
    500: '#9d95f5',
    600: '#887ef3',
    700: '#7367f1', //primary
    800: '#6258cd',
    900: '#5148a9',
  },
  gray: {
    0: '#ffffff',
    100: '#f5f5f5',
    200: '#d6d6d6',
    300: '#b8b8b8',
    400: '#999999',
    500: '#7a7a7a',
    600: '#5c5c5c',
    700: '#3d3d3d', //primary
    800: '#1f1f1f',
    900: '#000000',
  },
};

type MantineColorType = string | undefined;

interface ColorListProps {
  [key: string]: [
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
    MantineColorType,
  ];
}

export const colorsList: ColorListProps = {
  yellow: [
    colors.yellow[0],
    colors.yellow[100],
    colors.yellow[200],
    colors.yellow[300],
    colors.yellow[400],
    colors.yellow[500],
    colors.yellow[600],
    colors.yellow[700],
    colors.yellow[800],
    colors.yellow[900],
  ],
  green: [
    colors.green[0],
    colors.green[100],
    colors.green[200],
    colors.green[300],
    colors.green[400],
    colors.green[500],
    colors.green[600],
    colors.green[700],
    colors.green[800],
    colors.green[900],
  ],

  red: [
    colors.red[0],
    colors.red[100],
    colors.red[200],
    colors.red[300],
    colors.red[400],
    colors.red[500],
    colors.red[600],
    colors.red[700],
    colors.red[800],
    colors.red[900],
  ],
  cyan: [
    colors.cyan[0],
    colors.cyan[100],
    colors.cyan[200],
    colors.cyan[300],
    colors.cyan[400],
    colors.cyan[500],
    colors.cyan[600],
    colors.cyan[700],
    colors.cyan[800],
    colors.cyan[900],
  ],
  purple: [
    colors.purple[0],
    colors.purple[100],
    colors.purple[200],
    colors.purple[300],
    colors.purple[400],
    colors.purple[500],
    colors.purple[600],
    colors.purple[700],
    colors.purple[800],
    colors.purple[900],
  ],
  gray: [
    colors.gray[0],
    colors.gray[100],
    colors.gray[200],
    colors.gray[300],
    colors.gray[400],
    colors.gray[500],
    colors.gray[600],
    colors.gray[700],
    colors.gray[800],
    colors.gray[900],
  ],
};
export default colors;
